/* ==========================================================================
   LATYCE — Página de producto premium  |  assets/latyce-pdp.js
   Motor de interacciones. Vanilla, sin librerías.

   CLAVE DE DISEÑO: AUTODETECCIÓN
   Este archivo localiza por sí mismo el botón de compra del tema y lo marca.
   Gracias a eso NO hace falta editar `main-product.liquid` (105 KB), que es
   el archivo más frágil del tema.

   NO intercepta el envío del formulario: agregar al carrito sigue siendo
   100% del tema. La barra fija delega el clic en el botón real.
   ========================================================================== */

(function () {
  'use strict';

  var ROOT = '.latyce-pdp';
  var reduced = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;

  document.documentElement.classList.add('lat-js');

  /* --- Localiza el botón real de compra del tema --------------------- */
  function findAtc(scope) {
    return scope.querySelector('.product-form__submit') ||
           scope.querySelector('button[name="add"]') ||
           scope.querySelector('[data-lat-atc]');
  }

  /* --- 1. Entradas al hacer scroll ---------------------------------- */
  function initReveal(scope) {
    var items = scope.querySelectorAll('[data-lat-reveal]');
    if (!items.length) return;

    function showAll() {
      for (var i = 0; i < items.length; i++) items[i].classList.add('is-visible');
    }
    if (!('IntersectionObserver' in window) || reduced) { showAll(); return; }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    for (var i = 0; i < items.length; i++) io.observe(items[i]);
    window.setTimeout(showAll, 2000);   /* Red de seguridad. */
  }

  /* --- 2. Acordeónes accesibles ------------------------------------- */
  function initAccordions(scope) {
    var list = scope.querySelectorAll('[data-lat-accordion]');
    Array.prototype.forEach.call(list, function (acc) {
      if (acc.dataset.latReady === '1') return;
      acc.dataset.latReady = '1';

      var trigger = acc.querySelector('[data-lat-accordion-trigger]');
      var panel   = acc.querySelector('[data-lat-accordion-panel]');
      if (!trigger || !panel) return;

      var open = acc.classList.contains('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      trigger.addEventListener('click', function () {
        var willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        var group = acc.getAttribute('data-lat-accordion-group');

        if (group && willOpen) {
          var sibs = scope.querySelectorAll(
            '[data-lat-accordion][data-lat-accordion-group="' + group + '"]');
          Array.prototype.forEach.call(sibs, function (o) {
            if (o === acc) return;
            var t = o.querySelector('[data-lat-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
            o.classList.remove('is-open');
          });
        }

        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        acc.classList.toggle('is-open', willOpen);
      });
    });
  }

  /* --- 3. Barra de compra fija -------------------------------------- */
  function initSticky(scope) {
    var bar = document.querySelector('[data-lat-sticky]');
    var atc = findAtc(scope);
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    if (bar.dataset.latReady === '1') return;
    bar.dataset.latReady = '1';

    var anchor = atc.closest('.product-form__buttons') || atc;

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* Solo cuando el botón real quedó ARRIBA del viewport. */
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(anchor);

    var proxy = bar.querySelector('[data-lat-sticky-submit]');
    if (proxy) {
      proxy.addEventListener('click', function (ev) {
        ev.preventDefault();
        var real = findAtc(scope);
        if (real) real.click();
      });
      /* Refleja el estado agotado del botón real. */
      syncDisabled(atc, proxy);
    }

    syncStickyPrice(scope, bar);
  }

  function syncDisabled(real, proxy) {
    function apply() {
      var off = real.hasAttribute('disabled');
      proxy.disabled = off;
      proxy.textContent = off ? 'Agotado' : 'Agregar al carrito';
    }
    apply();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(apply)
      .observe(real, { attributes: true, attributeFilter: ['disabled'] });
  }

  /* El precio de la barra siempre debe coincidir con la variante elegida. */
  function syncStickyPrice(scope, bar) {
    var target = bar.querySelector('[data-lat-sticky-price]');
    var source = scope.querySelector('.product__info-container .price');
    if (!target || !source || !('MutationObserver' in window)) return;

    function copy() {
      var sale = source.querySelector('.price-item--sale') ||
                 source.querySelector('.price-item--regular');
      if (sale && sale.textContent.trim()) target.textContent = sale.textContent.trim();
    }
    copy();
    new MutationObserver(copy)
      .observe(source, { childList: true, subtree: true, characterData: true });
  }

  /* --- 4. Micro-feedback al pulsar ---------------------------------- */
  function initPress(scope) {
    var atc = findAtc(scope);
    if (!atc || atc.dataset.latPress === '1') return;
    atc.dataset.latPress = '1';
    atc.addEventListener('click', function () {
      atc.classList.add('is-pressed');
      window.setTimeout(function () { atc.classList.remove('is-pressed'); }, 400);
    }, { passive: true });
  }

  /* --- Arranque ------------------------------------------------------ */
  function init(container) {
    var host = container || document;
    var scope = host.querySelector ? host.querySelector(ROOT) : null;
    if (!scope && host.matches && host.matches(ROOT)) scope = host;
    if (!scope) scope = document.querySelector(ROOT);
    if (!scope) return;

    initReveal(scope);
    initAccordions(scope);
    initSticky(scope);
    initPress(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
